export default __webpack_public_path__ + "static/media/flagSound.897a1934.mp3";